<template>
    <div>
        <el-form ref="form" label-width="160px">
            <br/>
            <el-form-item label="销售下单号">
                <span>{{OrderData.OrderCode}}</span>
            </el-form-item>
            <el-form-item label="订单状态">
                <span>{{OrderData.OrderStatusName}}</span>
            </el-form-item>
            <el-form-item label="发货状态" v-show="OrderData.PackageId!==1201">
                <span>{{OrderData.SendStatusName}}</span>
            </el-form-item>
            <el-form-item label="代理商">
                <div>
                    <span>{{OrderData.AgentCode}} {{OrderData.AgentName}} {{OrderData.AgentAddress}} {{OrderData.AgentTel}}</span>
                </div>
            </el-form-item>
            <el-form-item label=" ">
                <span>{{OrderData.AccountInfo}}</span>
            </el-form-item>
            <el-form-item label="所选区域" v-if="OrderData.PackageId==1201">
                <span>{{OrderData.AreaApplyList[0].ProvName}} {{OrderData.AreaApplyList[0].CityName}} {{OrderData.AreaApplyList[0].AreaName}}</span>
            </el-form-item>
            <el-form-item label="销售下单时间">
                <span>{{OrderData.OrderTime}}</span>
            </el-form-item>
            <el-form-item label="业务员">
                <span>{{OrderData.SaleEmployeeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="下单对象">
                <span>{{OrderData.ObjectName}}</span>
            </el-form-item>
            <el-form-item label="所选套餐">
                <span>{{OrderData.OrderTitle}}</span>
            </el-form-item>
            <el-form-item label="" v-show="OrderData.PackageId==601||OrderData.PackageId==600">
                <el-table :data="OrderData.PackageUseList" border style="width: 80%;margin-left: 0px;">
                    <el-table-column label="使用开课设备" prop="Title">
                    </el-table-column>
                    <el-table-column prop="UseNum" label="使用数量">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="套餐明细" v-show="OrderData.PackageId==599">
                <el-table :data="OrderData.PackageList" border style="width: 80%;margin-left: 0px;">
                    <el-table-column label="套餐名称">
                        <template scope="scope">
                            {{scope.row.PackageName}}
                            <span v-if="scope.row.ChargeTypeName!==''">({{scope.row.ChargeTypeName}})</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ClassNum" label="开班数">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label="开通班级数" v-show="isShowClassNum">
                <span>{{OrderData.ClassNum}}</span>
            </el-form-item>

            <div v-if="OrderData.ProjectType==2 && OrderData.PackageId!=202">

                <el-form-item class='edit-form' label="Hi幼教样机数量" v-show="OrderData.ProtoTypeNum!==0">
                    <span>{{OrderData.ProtoTypeNum}}</span>
                </el-form-item>

                <el-form-item class='edit-form' label="样机已抵扣数" v-show="OrderData.ProtoTypeDeductibleNum!==0">
                    <span>{{OrderData.ProtoTypeDeductibleNum}}</span>
                </el-form-item>

                <el-form-item class='edit-form' label="此单需抵扣数" v-show="OrderData.OrderProtoTypeDeductibleNum!==0">
                    <span>{{OrderData.OrderProtoTypeDeductibleNum}}</span>
                </el-form-item>

            </div>

            <!--保留: <div v-show="OrderData.UnionRentTemplet.UnionRentList.length>0"> -->
            <div v-show="false">
                <el-form-item label="">
                    <span style="font-size:14px;font-weight:bold;">关联支付教室终端借用订单：{{OrderData.UnionRentTemplet.UnionRentRetainagePrice}}元</span>
                </el-form-item>
                <el-form-item label=" " class="w100">
                    <el-table :data="OrderData.UnionRentTemplet.UnionRentList" border style="width: 80%;margin-left: 0px;">
                        <el-table-column prop="SendCode" label="发货单号">
                        </el-table-column>
                        <el-table-column prop="OrderCode" label="订单号">
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </div>
            <!-- 退换货订单 -->
            <el-form-item label="商品" v-if="OrderData.PackageId==202 && OrderData.PackageId!==1201" class="w100">
                <el-table :data="OrderData.ReturnProductList" border style="width: 80%;margin-left: 0px;">
                    <el-table-column label="退换资源包" align="center">
                        <el-table-column prop="ReturnProName" label="商品名称"></el-table-column>
                        <el-table-column prop="ReturnNum" label="商品数量"></el-table-column>
                    </el-table-column>
                    <el-table-column label="预计换货资源包" align="center">
                        <el-table-column prop="ChangeProName" label="商品名称"></el-table-column>
                        <el-table-column prop="ReturnNum" label="商品数量"></el-table-column>
                    </el-table-column>
                </el-table>
                <el-table v-if="OrderData.ActualProductList!=''" :data="OrderData.ActualProductList" border style="width: 80%;margin-left: 0px;margin-top:10px;">
                    <el-table-column label="实际退还资源包" prop="ActualProName"></el-table-column>
                    <el-table-column label="数量" prop="ActualNum"></el-table-column>
                </el-table>
                <el-table v-if="OrderData.ReturnProductNewList!=''" :data="OrderData.ReturnProductNewList" border style="width: 80%;margin-left: 0px;margin-top:10px;">
                    <el-table-column label="已换资源包" prop="ChangeProName"></el-table-column>
                    <el-table-column label="数量" prop="ChangeNum"></el-table-column>
                </el-table>
            </el-form-item>
            <!-- 其他订单 -->
            <el-form-item v-else label="商品" v-show="OrderData.ProductList!='' && OrderData.PackageId!==1201" class="w100">
                <el-table :data="OrderData.ProductList" border style="width: 80%;margin-left: 0px;">
                    <el-table-column prop="ProductName" label="商品名称">
                    </el-table-column>
                    <el-table-column prop="ProNum" label="商品数量">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <!-- 合同款查看审核页面新增：所选区域；商品显示：该订单不存在实物商品 -->
            <el-form-item label="商品" v-show="OrderData.PackageId==1201" class="w100">
                <el-table :data="[]" empty-text="该订单不存在实物商品" border style="width: 90%;">
                    <el-table-column label="商品名称">
                    </el-table-column>
                    <el-table-column label="商品数量">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item label=" " v-show="UnionRentListShow">
                <span style="">使用借用教室终端（不发货）:{{OrderData.UnionRentTemplet.UnionRentList.length}}</span>
            </el-form-item>

            <el-form-item label=" " v-show="true">
                <span style="font-size:16px;font-weight:bold;" v-if="OrderData.PackageId==202">管理费:</span>
                <span v-else style="font-size:16px;font-weight:bold;">销售总价:</span>
                <span style="font-size:16px;font-weight:bold;">{{OrderData.PreOrderPrice}}元</span>
                <span style="font-size:16px;font-weight:bold;margin-left:15px;">{{OrderData.OrderUnionRentPrice}}</span>
            </el-form-item>
            <el-form-item label=" " v-show="true">
                <span class="bigSp">应付:</span>
                <span class="bigSp">{{OrderData.OrderActualPrice}}元 (备注:{{OrderData.DeductibleInfo}})</span>
            </el-form-item>
            <el-form-item label="赠品" v-show="OrderData.GiftList!='' && OrderData.PackageId!==10021">
                <el-table :data="OrderData.GiftList" border style="width: 30%;margin-left: 25px;">
                    <el-table-column prop="ProductName" label="赠品名称">
                    </el-table-column>
                    <el-table-column prop="ProNum" label="赠品数量">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <!-- <el-form-item label="支付方式">
                <span>{{OrderData.PayWayName}}</span>
            </el-form-item> -->
            <!-- PayWay:1支付宝 4微信 5pos机  -->
            <!-- <el-form-item label="银行名称" v-if="this.OrderData.PayWay==5">
                <span>{{OrderData.Bank}}</span>
            </el-form-item>
            <el-form-item :label="payCodeName" v-if="payCodeName!='' ">
                <span>{{OrderData.PayNo}}</span>
            </el-form-item> -->
            <!-- <el-row v-for="(item,index) in this.OrderData.PayList">
                <el-form-item label="支付方式">
                <span>{{item.PayWayName}}</span>
                </el-form-item>
                <el-form-item label="银行名称" v-if="item.PayWay==5">
                    <span>{{item.BankName}}</span>
                </el-form-item>
                <el-form-item :label="payCodeName" v-if="payCodeName!='' ">
                    <span>{{item.Trade_No}}</span>
                </el-form-item>
            </el-row> -->
            <el-row v-for="(item,index) in this.OrderData.PayList">
                <el-form-item :label="'支付方式-' +(index+1)">
                    <span>{{item.PayWayName}}</span>
                </el-form-item>
                <el-form-item label="支付金额">
                    <span>{{item.OrderActualPrice}}</span>
                </el-form-item>
                <el-form-item label="支付凭证" v-if="item.PayWay==5">
                    <div id="ImgPrev" v-for="item2 in item.changePic">
                        <div class="post-format-content">
                            <div class="post-thumbnail">
                                <img id="myProPic" :src="item2.Url" class="attachment-thumbnail wp-post-image">
                            </div>
                            <div class="content-wrap">
                                <span class="entry-title">
                                    <span class="featured-image" @click="LookPicture(item2.Url)">
                                        <i class="el-icon-view"></i>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="支付凭证单号" v-if="item.Trade_No!='' ">
                    <span>{{item.Trade_No}}</span>
                </el-form-item>
                <el-form-item label="支付说明" v-if="item.PayWay==8 ">
                    <span>{{item.PayRemark}}</span>
                </el-form-item>
            </el-row>
            <el-form-item label="凭证" v-show="OrderData.VoucherPic.length>0">
                <div id="ImgPrev" v-for="(item,index) in OrderData.VoucherPic">
                    <div class="post-format-content">
                        <div class="post-thumbnail">
                            <img id="myProPic" :src="item.Url" class="attachment-thumbnail wp-post-image">
                        </div>
                        <div class="content-wrap">
                            <span class="entry-title">
                                <span class="featured-image" @click="LookPicture(item.Url)">
                                    <i class="el-icon-view"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- <div class="show-img-ctn uclear">
                    <template v-for="(item,index) in OrderData.VoucherPic">
                        <div class="show-img-cell" @click="LookPicture(item.Url)">
                            <img :alt="item.Name" :src="item.Url" />
                            <i class="el-icon-view"></i>
                        </div>
                    </template>
                </div> -->
            </el-form-item>
            <el-form-item label="租用申请表" v-show="OrderData.ApplyPic.length>0">
                <div id="ImgPrev" v-for="(item,index) in OrderData.ApplyPic">
                    <div class="post-format-content">
                        <div class="post-thumbnail">
                            <img id="myProPic" :src="item.Url" class="attachment-thumbnail wp-post-image">
                        </div>
                        <div class="content-wrap">
                            <span class="entry-title">
                                <span class="featured-image" @click="LookPicture(item.Url)">
                                    <i class="el-icon-view"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- <div class="show-img-ctn uclear">
                    <template v-for="(item,index) in OrderData.ApplyPic">
                        <div class="show-img-cell" @click="LookPicture(item.Url)">
                            <img :alt="item.Name" :src="item.Url" />
                        </div>
                    </template>
                </div> -->
            </el-form-item>
            <!-- <el-form-item label="支付流水">
                <span>{{OrderData.PayNo}}</span>
            </el-form-item> -->
            <el-row>
                <el-form-item label="代理商总借款" v-if="showPrice.LendTotal!==0">
                    <span>{{showPrice.LendTotal}}元</span>
                </el-form-item>
                <el-form-item label="其中智趣坞18首期课程借款" v-if="showPrice.BookFirstLend!==0">
                    <span>{{showPrice.BookFirstLend}}元</span>
                </el-form-item>
                <el-form-item label="智趣坞18二期课程借款" v-if="showPrice.BookTwoLend!==0">
                    <span>{{showPrice.BookTwoLend}}元</span>
                </el-form-item>
                <el-form-item label="智趣坞设备借款" v-if="showPrice.BookEquipLend!==0">
                    <span>{{showPrice.BookEquipLend }}元</span>
                </el-form-item>
                <el-form-item label="智趣坞图书借款" v-if="showPrice.BookBookLend!==0">
                    <span>{{showPrice.BookBookLend}}元</span>
                </el-form-item>
                <el-form-item label="Hi幼教B政策17年项目借款" v-if="showPrice.LendHiMoney!==0">
                    <span>{{showPrice.LendHiMoney}}元</span>
                </el-form-item>
                <el-form-item label="联帮在线17年项目借款" v-if="showPrice.LendUnionMoney!==0">
                    <span>{{showPrice.LendUnionMoney}}元</span>
                </el-form-item>
                <el-form-item label="智趣坞独家首期应收款" v-if="showPrice.BookFirstOld!==0">
                    <span>{{showPrice.BookFirstOld}}元</span>
                </el-form-item>
                <el-form-item label="智趣坞独家二期应收款" v-if="showPrice.BookTwoOld!==0">
                    <span>{{showPrice.BookTwoOld}}元</span>
                </el-form-item>
            </el-row>
            <div v-show="isPayWayShow && !isMeetOrder">
                <el-form-item label="收款银行">
                    <span>{{OrderData.Bank}}</span>
                </el-form-item>
                <el-form-item label="收款流水号">
                    <span>{{OrderData.BankRecord}}</span>
                </el-form-item>
            </div>
            <el-form-item label="收款金额" v-show="!isMeetOrder">
                <span>{{OrderData.AmountCollected}}</span>
            </el-form-item>
            <el-dialog v-model="PictureVisible" size="small">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
            <div v-show="OrderData.PackageId!==1201">
                <div v-show="isShowJszdByPolicyType">
                    <h3>教室终端（园所）</h3>
                    <el-form-item class='edit-form w100' label="收货地址">
                        <span>{{OrderData.AgentConsignee}}</span>
                    </el-form-item>
                    <el-form-item class='edit-form w100' label="收货人及联系方式">
                        <span>{{OrderData.Consignee}}&nbsp;&nbsp;{{OrderData.ConsigneeTel}}</span>
                    </el-form-item>
                    <el-form-item class='edit-form w100' label="寄送方式">
                        <span>{{OrderData.SchoolSendModeName}}</span>
                    </el-form-item>
                    <el-form-item class='edit-form w100' label="寄送支付方式">
                        <span>{{OrderData.SchoolPayModeName}}</span>
                    </el-form-item>
                </div>

                <div>
                    <h3 v-show="isShowJszdByPolicyType">资源包（代理商）</h3>
                    <div v-if='OrderData.PackageId!==1200 && OrderData.PackageId!==10021'>
                        <!-- 以下是代理商地址 -->
                        <el-form-item class='edit-form w100' label="收货地址">
                            <span>{{OrderData.AG_Address}}</span>
                        </el-form-item>
                        <el-form-item class='edit-form w100' label="收货人及联系方式">
                            <span>{{OrderData.AG_Consignee}}&nbsp;&nbsp;{{OrderData.AG_ConsigneeTel}}</span>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <!-- 以下是园所地址（OrderData.PackageId==1200智趣坞套餐 或10021hi幼教套餐展现 ） -->
                        <el-form-item class='edit-form w100' label="收货地址">
                            <span>{{OrderData.AgentConsignee}}</span>
                        </el-form-item>
                        <el-form-item class='edit-form w100' label="收货人及联系方式">
                            <span>{{OrderData.Consignee}}&nbsp;&nbsp;{{OrderData.ConsigneeTel}}</span>
                        </el-form-item>
                    </div>
                    <el-form-item class='edit-form w100' label="下单备注">
                        <span>{{OrderData.OrderRemark}}</span>
                    </el-form-item>
                    <el-form-item label="寄送方式">
                        <span>{{OrderData.SendModeName}}</span>
                    </el-form-item>
                    <el-form-item label="支付方式">
                        <span>{{OrderData.PayModeName}}</span>
                    </el-form-item>
                </div>
            </div>
            <h3>备注</h3>
            <el-form-item label="财务审核备注">
                <span>{{OrderData.AuditRemark}}</span>
            </el-form-item>
            <el-form-item label="对外备注">
                <span v-if="OrderData.InternalRemark!==null">{{OrderData.InternalRemark}}</span>
                <span v-else>无</span>
            </el-form-item>
            <el-form-item label="对内备注">
                <span v-if="OrderData.AuditNotes!==''">{{OrderData.AuditNotes}}</span>
                <span v-else>无</span>
            </el-form-item>
            <el-form-item label="退款明细:" v-show="refundData.length">
                <el-table :data="refundData" border style="width: 90%;" router>
                    <el-table-column width="200" label="订单号" prop="OrderCode" align="center"></el-table-column>
                    <el-table-column width="200" label="项目" prop="OperPriceTypeName" align="center"></el-table-column>
                    <el-table-column width="200" label="变动明细" prop="Remark" align="center"></el-table-column>
                    <el-table-column label="余额变动" width="150" align="center">
                        <template scope="scope">
                            <span v-if="scope.row.AddMoney==0">-{{scope.row.CostMoney}}</span>
                            <span v-else-if="scope.row.CostMoney==0" style="color:red;">+{{scope.row.AddMoney}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" label="可用金额" prop="AfterMoney" align="center"></el-table-column>
                    <el-table-column width="200" label="订单状态" prop="OrderStatusName" align="center"></el-table-column>
                    <el-table-column width="200" label="操作人" prop="OperName" align="center"></el-table-column>
                    <el-table-column width="200" label="操作时间" prop="AddTime" align="center"></el-table-column>
                </el-table>
            </el-form-item>
        </el-form>
        <el-row>
            <el-col :span="24" style="display: flex;justify-content: center;margin-bottom: 15px">
                <el-button @click="viewSure">我知道了</el-button>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import viewPhoto from "src/common/js/viewPhoto";
import { GetERP_OrderById } from "@api/orderApi.js";
import NProgress from "nprogress";
import { cloneDeep, util, isCorrectVal, isDate, lg } from "utils";
import $http from "$http";

export default {
  data() {
    return {
      sysSid: "",
      sysSession: "",
      OrderData: {
        UnionRentTemplet: {
          UnionRentList: []
        },
        ApplyPic: [],
        VoucherPic: []
      },
      IsShow: false,
      PictureVisible: false,
      dialogImageUrl: "",
      refundData: [],
      changePic: [],
      showPrice: {
        BookFirstLend: 0,
        BookTwoLend: 0,
        BookEquipLend: 0,
        BookBookLend: 0,
        LendHiMoney: 0,
        LendUnionMoney: 0,
        LendTotal: 0,
        BookFirstOld: 0,
        BookTwoOld: 0
      }
    };
  },
  computed: {
    getAllPrice() {
      return 120;
    },
    isShowClassNum() {
      if (this.OrderData.PackageId != 106 && this.OrderDataProjectType == 2) {
        return true;
      }
      return false;
    },
    isShowJszdByPolicyType() {
      if (this.OrderData.PackageId == 101) {
        return true;
      }
      return false;
    },
    isShowIsFirst() {
      if (this.OrderData.IsFirst > 0) {
        return true;
      }
      return false;
    },
    UnionRentListShow() {
      let PackageId = this.OrderData.PackageId;
      if (
        PackageId == 110 ||
        PackageId == 111 ||
        PackageId == 112 ||
        PackageId == 113
      ) {
        return true;
      }
      return false;
    },
    isMeetOrder() {
      if (
        this.OrderData.PackageId == 1001 ||
        this.OrderData.PackageId == 1002 ||
        this.OrderData.PackageId == 1003
      ) {
        return true;
      } else {
        return false;
      }
    },
    isPayWayShow() {
      let payWay = $.trim(this.OrderData.PayWay);
      // if (payWay.indexOf("3") > -1) {
      //     return false;
      // } else if (payWay.indexOf("2") > -1) {
      //     return true;
      // }
      if (payWay.indexOf("2") > -1) {
        return true;
      } else {
        return false;
      }
    }
    // payCodeName(){
    //     for(let i=0;i<this.OrderData.PayList.length;i++){

    //         if(this.OrderData.PayList[i].PayWay==1){
    //             return "支付凭证单号"
    //         }else if(this.OrderData.PayList[i].PayWay==4){
    //             console.log(this.OrderData.PayList[i].PayWay)
    //             return "交易单号"
    //         }else{
    //             return ''
    //         }
    //     }
    // }
  },
  methods: {
    LookPicture(Url) {
      viewPhoto.show({
        showImgId: "", //指定id显示图片
        thumbList: [{ src: Url, id: "" }]
      });
    },
    getList() {
      let param = {
        Sid: this.sysSid,
        Session: this.sysSession,
        Id: this.$route.query.Id
      };
      GetERP_OrderById(param).then(res => {
        util.doResult(this, res, () => {
          this.OrderData = res.data.Data;
          this.showPrice = util.extendByObj(
            this.showPrice,
            this.OrderData.LendInfo
          );
          if (this.OrderData.SendGoods.length > 0) {
            this.IsShow = true;
          } else {
            this.IsShow = false;
          }
          if (this.OrderData.PackageId == 10021) {
            let arr = [];
            for (let i = 0; i < this.OrderData.ProductList.length; i++) {
              if (this.OrderData.ProductList[i].ProId == 320) {
                arr.push(this.OrderData.ProductList[i]);
              }
              if (this.OrderData.ProductList[i].ProId == 0) {
                arr.push(this.OrderData.ProductList[i]);
              }
            }

            this.OrderData.ProductList = arr;
          }

          for (let i = 0; i < this.OrderData.PayList.length; i++) {
            if (this.OrderData.PayList[i].VoucherPic !== "") {
              this.OrderData.PayList[i].changePic = [];
              let picArr = this.OrderData.PayList[i].VoucherPic.split(",");
              for (let j = 0; j < picArr.length; j++) {
                this.OrderData.PayList[i].changePic.push({ Url: picArr[j] });
              }
            }
          }
          //赋值套餐明细packageDetails
        });
      });
    },
    viewSure() {
      //util.redirect(this, "/Order/SaleOrder", false);
      window.history.go(-1);
    }
  },
  created() {
    var user = sessionStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      this.sysSid = user.Sid || "";
      this.sysSession = user.Session || "";
    }
    this.getList();
    if (this.$route.query.from == "refund") {
      this.$store.dispatch("getRouterName", "退款审核查看");
      let params = {
        Sid: this.sysSid,
        Session: this.sysSession,
        OrderCode: this.$route.query.OrderCode
      };
      $http.get("api/Common/GetERP_PriceLogByPage", params).then(res => {
        util.doResult(this, res, () => {
          this.refundData = res.data.Data;
        });
      });
    } else {
      this.$store.dispatch("getRouterName", "财务审核查看");
    }
    //this.$store.dispatch("getRouterName","添加单品")
  }
};
</script>

<style scoped lang="scss">
.show-img-cell {
  border: 1px solid #ccc;
}

.bigSp {
  font-size: 16px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// ViewOrder.vue?5818356f